import { render, staticRenderFns } from "./emailSetting.vue?vue&type=template&id=7f631d98"
import script from "./emailSetting.vue?vue&type=script&lang=js"
export * from "./emailSetting.vue?vue&type=script&lang=js"
import style0 from "./emailSetting.vue?vue&type=style&index=0&id=7f631d98&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f631d98')) {
      api.createRecord('7f631d98', component.options)
    } else {
      api.reload('7f631d98', component.options)
    }
    module.hot.accept("./emailSetting.vue?vue&type=template&id=7f631d98", function () {
      api.rerender('7f631d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/emailSetting.vue"
export default component.exports